import { render, staticRenderFns } from "./VisitHistoryModal.vue?vue&type=template&id=40baf191&"
import script from "./VisitHistoryModal.vue?vue&type=script&lang=js&"
export * from "./VisitHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./VisitHistoryModal.vue?vue&type=style&index=0&id=40baf191&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports